import 'readmore-js';

// Readmore reviews
$(document).ready(function () {
	$('.js-review__readmore').readmore({
		collapsedHeight: 110,
		moreLink: `<button class="interactive">${BX.message('1PDR_REVIEWS_READMORE')}</button>`,
		lessLink: `<button class="interactive">${BX.message('1PDR_REVIEWS_HIDE')}</button>`,
		blockCSS: 'display: inline-block; font-size: 14px;',
	});

	$('.js-reviews-slider__readmore').readmore({
		collapsedHeight: 120,
		moreLink: `<button class="interactive">${BX.message('1PDR_REVIEWS_READMORE')}</button>`,
		lessLink: `<button class="interactive">${BX.message('1PDR_REVIEWS_HIDE')}</button>`,
		blockCSS: 'display: inline-block; font-size: 12px; margin-top: 8px;',
	});
});
